import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import type { AppDispatch, RootState } from './store';

/* Use throughout your app instead of plain `useDispatch` and `useSelector` */
export const useAppDispatch = () => useDispatch<AppDispatch>();
/** Typed selector hook for Redux store state. */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
